import React from 'react';
import { Link } from 'react-router-dom';
import { Ear } from '@phosphor-icons/react';

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-zinc-50">
      <header className="bg-zinc-900 text-white">
        <div className="max-w-4xl mx-auto px-4 py-6 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <Ear size={28} weight="bold" />
            <span className="font-heading font-bold text-lg tracking-wider">HAMAC SOLUTIONS</span>
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-10">
        <div className="bg-white border border-zinc-200 rounded-sm p-6 sm:p-10">
          <h1 className="font-heading text-2xl sm:text-3xl font-bold text-zinc-900 mb-8 pb-4 border-b-2 border-zinc-900">
            POLITIQUE DE CONFIDENTIALIT&Eacute;
          </h1>

          <div className="space-y-8 text-sm sm:text-base text-zinc-700 leading-relaxed">
            <section>
              <h2 className="font-heading font-semibold text-lg text-zinc-900 mb-3">1. Identit&eacute; du responsable du traitement</h2>
              <p>Le site <a href="https://hamacsolutions.com" className="text-zinc-900 underline font-medium">https://hamacsolutions.com</a> est &eacute;dit&eacute; par la soci&eacute;t&eacute; <strong>HAMAC SOLUTIONS</strong>, soci&eacute;t&eacute; &agrave; responsabilit&eacute; limit&eacute;e (SARL) unipersonnelle au capital social de 10 000 &euro;, immatricul&eacute;e sous le SIREN <strong>928 122 761</strong> (RCS Bourg-en-Bresse), repr&eacute;sent&eacute;e par son g&eacute;rant Jordan CLAUDE.</p>
              <p className="mt-2">Le responsable du traitement des donn&eacute;es est HAMAC SOLUTIONS.</p>
              <p>Contact : <a href="mailto:jordan.claude@pm.me" className="text-zinc-900 underline font-medium">jordan.claude@pm.me</a></p>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-zinc-900 mb-3">2. Donn&eacute;es collect&eacute;es</h2>
              <h3 className="font-semibold text-zinc-800 mb-2">Donn&eacute;es professionnelles (clients B2B)</h3>
              <ul className="list-disc pl-6 space-y-1">
                <li>Adresse e-mail professionnelle</li>
                <li>Num&eacute;ro de t&eacute;l&eacute;phone professionnel</li>
                <li>Adresse de l'entreprise</li>
              </ul>
              <h3 className="font-semibold text-zinc-800 mt-4 mb-2">Donn&eacute;es li&eacute;es aux commandes</h3>
              <ul className="list-disc pl-6 space-y-1">
                <li>R&eacute;f&eacute;rence patient (non nominative recommand&eacute;e)</li>
                <li>Donn&eacute;es techniques n&eacute;cessaires &agrave; la fabrication des embouts sur mesure</li>
              </ul>
              <div className="bg-amber-50 border border-amber-200 rounded-sm p-4 mt-4">
                <p className="text-amber-800 font-medium text-sm">HAMAC SOLUTIONS ne demande pas de donn&eacute;es directement identifiantes des patients (nom, pr&eacute;nom). Les clients sont responsables des donn&eacute;es qu'ils saisissent.</p>
              </div>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-zinc-900 mb-3">3. Finalit&eacute;s du traitement</h2>
              <p>Les donn&eacute;es sont utilis&eacute;es pour :</p>
              <ul className="list-disc pl-6 space-y-1 mt-2">
                <li>Gestion des comptes clients</li>
                <li>Traitement et suivi des commandes</li>
                <li>Fabrication des dispositifs sur mesure</li>
                <li>Logistique et livraison</li>
                <li>Support client et SAV</li>
                <li>Communication professionnelle</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-zinc-900 mb-3">4. Base l&eacute;gale</h2>
              <p>Les traitements reposent sur :</p>
              <ul className="list-disc pl-6 space-y-1 mt-2">
                <li>L'ex&eacute;cution contractuelle</li>
                <li>L'int&eacute;r&ecirc;t l&eacute;gitime</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-zinc-900 mb-3">5. Dur&eacute;e de conservation</h2>
              <p>Les donn&eacute;es sont conserv&eacute;es pendant la dur&eacute;e de la relation commerciale puis archiv&eacute;es conform&eacute;ment aux obligations l&eacute;gales.</p>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-zinc-900 mb-3">6. Destinataires des donn&eacute;es</h2>
              <p>Les donn&eacute;es sont accessibles uniquement :</p>
              <ul className="list-disc pl-6 space-y-1 mt-2">
                <li>Aux &eacute;quipes internes HAMAC SOLUTIONS</li>
                <li>Aux prestataires techniques n&eacute;cessaires (h&eacute;bergement, outils informatiques)</li>
              </ul>
              <p className="mt-2 font-medium">Aucune donn&eacute;e n'est vendue ni c&eacute;d&eacute;e.</p>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-zinc-900 mb-3">7. S&eacute;curit&eacute; des donn&eacute;es</h2>
              <p>HAMAC SOLUTIONS met en oeuvre des mesures techniques et organisationnelles appropri&eacute;es pour prot&eacute;ger les donn&eacute;es.</p>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-zinc-900 mb-3">8. Donn&eacute;es sensibles et r&ocirc;le de sous-traitant</h2>
              <p>Dans le cadre des commandes, certaines donn&eacute;es techniques peuvent &ecirc;tre associ&eacute;es &agrave; des dispositifs m&eacute;dicaux. HAMAC SOLUTIONS agit en tant que sous-traitant au sens du RGPD. Les audioproth&eacute;sistes clients restent responsables du traitement des donn&eacute;es patients.</p>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-zinc-900 mb-3">9. Droits des utilisateurs</h2>
              <p>Conform&eacute;ment au R&egrave;glement g&eacute;n&eacute;ral sur la protection des donn&eacute;es (RGPD) et &agrave; la loi &laquo;&nbsp;Informatique et Libert&eacute;s&nbsp;&raquo; du 6 janvier 1978 modifi&eacute;e, les utilisateurs disposent des droits suivants :</p>
              <ul className="list-disc pl-6 space-y-1 mt-2">
                <li>Droit d'acc&egrave;s</li>
                <li>Droit de rectification</li>
                <li>Droit de suppression</li>
                <li>Droit d'opposition</li>
                <li>Droit &agrave; la limitation du traitement</li>
              </ul>
              <p className="mt-2">Ces droits peuvent &ecirc;tre exerc&eacute;s en contactant : <a href="mailto:jordan.claude@pm.me" className="text-zinc-900 underline font-medium">jordan.claude@pm.me</a></p>
              <p className="mt-2">En cas de r&eacute;clamation, les utilisateurs peuvent &eacute;galement s'adresser &agrave; la <strong>CNIL</strong> (<a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-zinc-900 underline font-medium">www.cnil.fr</a>).</p>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-zinc-900 mb-3">10. Cookies</h2>
              <p>Le site utilise des cookies pour le fonctionnement et l'am&eacute;lioration de l'exp&eacute;rience utilisateur. Les utilisateurs peuvent configurer leur navigateur pour accepter ou refuser les cookies.</p>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-zinc-900 mb-3">11. Modification</h2>
              <p>Cette politique peut &ecirc;tre modifi&eacute;e &agrave; tout moment. La version en vigueur est celle publi&eacute;e sur le site au moment de la consultation.</p>
            </section>
          </div>

          <div className="mt-10 pt-6 border-t border-zinc-200 text-xs text-zinc-400">
            <p>Version 1.1 — Derni&egrave;re mise &agrave; jour : F&eacute;vrier 2026</p>
          </div>
        </div>
      </main>
    </div>
  );
}
